import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType } from 'ng-k-button';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { AsbestosisService } from '../../../services/asbestosis.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/services/shared.service';
import { AsbestosRadiologicalProgressionService } from 'src/app/services/asbestos-radiological-progression.service';

@Component({
  selector: 'app-claim-medical',
  templateUrl: './claim-medical.component.html',
  styleUrls: ['./claim-medical.component.scss']
})
export class ClaimMedicalComponent implements OnInit {
  @ViewChild('confirmDeleteProfile', { static: true }) confirmDeleteProfile!: TemplateRef<any>;
  @ViewChild('confirmDeleteRadProgression', { static: true }) confirmDeleteRadProgression!: TemplateRef<any>;
  @Input() claimId: any;
  @Input() claimUsecaseName: any;

  KButtonType = KButtonType;
  public searchMedicalRecordsFilterForm: any = {};
  public allImmunoProfiles = [];
  public allRadiologicalProg = [];
  public selectedProfile: any = {};
  public selectedRadProg: any = {};
  public filter: any = {};

  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public successText!: string;
  public errorText!: string;
  public timeout!: number;
  public isDeleteProfileAllowed: boolean = false;
  public isDeleteRadProgressionAllowed: boolean = false;



  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public loaderService: GlobalLoadingService,
    private asbestosisService: AsbestosisService,
    private asbestosRadProgService: AsbestosRadiologicalProgressionService,
    private modalService: NgbModal,
    private sharedService: SharedService

  ) { }

  ngOnInit(): void {
    this.getRightsByToken();
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['id']);
    });
    if (this.claimUsecaseName === 'carcinoma-of-the-lung' || this.claimUsecaseName === 'mesothelioma') {
      this.retrieveImmunoProfiles(null);
      this.searchMedicalRecordsFilterFormValidation();
    }
    this.retrieveRadiologicalProgressions();
  }

  createImmunoProfiles() {
    this.router.navigate([`${this.claimUsecaseName}/immunohistology-profiling/create-profile/`, this.claimId]);
  }

  public searchMedicalRecordsFilterFormValidation() {
    this.searchMedicalRecordsFilterForm = this.fb.group({
      keyword: '',
    });
  }

  public retrieveImmunoProfiles(keyword: any) {
    this.loaderService.startLoadingIndicator('retrieveImmunoProfiles');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.payload = {
      'search': keyword ? keyword : ''
    };

    thisObj.asbestosisService.getAntigenMarkers(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('retrieveImmunoProfiles');
        console.log(result)
        thisObj.allImmunoProfiles = [];
        thisObj.allImmunoProfiles = result.data.immunohistologyDetails.profiles;
        console.log(thisObj.allImmunoProfiles)
      }
    }, err => {
      this.loaderService.stopLoadingIndicator('retrieveImmunoProfiles');
    });
  }

  public retrieveRadiologicalProgressions() {
    this.loaderService.startLoadingIndicator('retrieveRadiologicalProgressions');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    this.allRadiologicalProg = [];

    thisObj.asbestosRadProgService.retrieveRadiologicalProgression(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('retrieveRadiologicalProgressions');
        console.log(result)
        this.allRadiologicalProg = result.data;
      }
    }, err => {
      this.loaderService.stopLoadingIndicator('retrieveRadiologicalProgressions');
    });
  }

  editProfile($event:Event, profile: any) {
    $event.stopPropagation();
    this.router.navigate([`${this.claimUsecaseName}/immunohistology-profiling/edit-profile`, this.claimId, profile.id]);
  }

  public getRightsByToken() {
    let getRightsParam = [{ actionObject: 'ImmunoProfile', actionVerb: ['Delete'] },{ actionObject: 'AsbestosDisability', actionVerb: ['Delete'] }];
    this.sharedService.getRightsByToken(getRightsParam).subscribe(
      (result: any) => {
        
        result?.forEach((res: any) => {
          if (
            res.statusCode == 200 &&
            res.data.actionObject === 'ImmunoProfile' &&
            res.data.actionVerb === 'Delete'
          ) {
            this.isDeleteProfileAllowed = res.data.isAllowed;
          }

          if (
            res.statusCode == 200 &&
            res.data.actionObject === 'AsbestosDisability' &&
            res.data.actionVerb === 'Delete'
          ) {
            this.isDeleteRadProgressionAllowed = res.data.isAllowed;
          }
        });
      },
      (err: any) => {
        console.log('error', err?.error);
      }
    );
  }

  confirmDeleteProfileModal($event:Event, profile: any) {
    $event.stopPropagation();
    this.selectedProfile = profile;
    console.log(this.selectedProfile)
    const modalRef = this.modalService.open(this.confirmDeleteProfile,
      { ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl' })

    return modalRef.result.then((result: any) => {
      return result;
    }).catch((error) => {
      console.log(error)
      return false;
    })
  }

  public deleteImmunoProfile() {
    this.loaderService.startLoadingIndicator('deleteImmunoProfile');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.profileId = this.selectedProfile.id;
    thisObj.asbestosisService.deleteImmunoProfile(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.modalService.dismissAll();
        this.loaderService.stopLoadingIndicator('deleteImmunoProfile');
        thisObj.retrieveImmunoProfiles(null);
        this.successText = 'Immunohistological profile deleted successfully';
        this.showMessage('success', 2000);
        setTimeout(() => {
          this.displaySuccess = false;
        }, 2010);
      }
    }, err => {
      this.loaderService.stopLoadingIndicator('deleteImmunoProfile');
    });

  }

  resetSearchMedicalRecordsFilterForm(form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      form.reset();
      this.filter.searchKeyword = '';
      thisObj.retrieveImmunoProfiles(this.filter.searchKeyword);
    }
  }

  submitSearchMedicalRecordsFilterForm($event: any, form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      this.filter.searchKeyword = form.value.keyword;
      this.retrieveImmunoProfiles(this.filter.searchKeyword)
      $event.preventDefault();
    }
  }

  createNewChart() {
    this.router.navigate([`${this.claimUsecaseName}/radiological-progression/create-chart/`, this.claimId]);
  }

  editRadiologicalProgression($event:Event, radProgId: any) {
    $event.stopPropagation();
    this.router.navigate([`${this.claimUsecaseName}/radiological-progression/edit-chart/`, this.claimId, radProgId]);
  }

  viewRadiologicalProgression($event:Event, radProgId: any, title: any) {
    $event.stopPropagation();
    this.router.navigate([`${this.claimUsecaseName}/radiological-progression/view-chart/`, this.claimId, radProgId, title]);
  }

  confirmDeleteModalRadiologicalProgression($event:Event, radProg: any) {
    $event.stopPropagation();
    this.selectedRadProg = radProg;
    console.log(this.selectedRadProg)
    const modalRef = this.modalService.open(this.confirmDeleteRadProgression,
      { ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl' })

    return modalRef.result.then((result: any) => {
      return result;
    }).catch((error) => {
      console.log(error)
      return false;
    })
  }

  deleteRadProgression() {
    this.loaderService.startLoadingIndicator('deleteRadProgression');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.id = this.selectedRadProg._id;
    thisObj.asbestosRadProgService.deleteRadiologicalProgression(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.modalService.dismissAll();
        this.loaderService.stopLoadingIndicator('deleteRadProgression');
        thisObj.retrieveRadiologicalProgressions();
        this.successText = 'Radiological Progression deleted successfully';
        this.showMessage('success', 2000);
        setTimeout(() => {
          this.displaySuccess = false;
        }, 2010);
      }
    }, err => {
      this.loaderService.stopLoadingIndicator('deleteRadProgression');
    });
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }


}
